import React from "react";
import Cards from "../cards";
import { FaRegImages } from "react-icons/fa";

export const NoImageAvailableWithLink = ({...props}) => {

  const viewImageButtonStyle = {
    position:'absolute',
    display: 'flex',
    width: `${props?.modal ? '95%' : '134px'}`,
    height: '32px',
    padding: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    borderRadius: '6px',
    background: '#FFF',
    color: '#F37021',
    fontSize:'14px',
    fontWeight:'700',
    textDecoration: 'none',
    bottom: '8px'
  }

  return (
    <a
      style={{
        position: "relative",
        display: "flex",
        flexDirection:'column',
        alignItems: "center",
        justifyContent:'center',
        borderRadius:'8px',
        margin:`${props.margin ? props.margin : '0px 8px 0px 0px'}`,
        background:'#F1E5F1',
        minHeight:`${props?.minHeight}`,
        minWidth:`${props?.minWidth}`,
        maxWidth:`${props?.maxWidth}`,
        maxHeight:`${props?.maxHeight}`,
        padding:'8px'
      }}
      href={props.imagesURL}
      rel="noreferrer" 
      target="_blank"
    >
      <img style={{marginBottom:'18px', width:`${props.imgWidth}`, height:`${props.imgHeight}`}} src="../assets/icons/tractor_icon.svg" alt="" />
						{!props.isMobile ? <div  style={viewImageButtonStyle} >
              <FaRegImages
                          style={{ height: "18px", width: "18px" }}
              />
              View Images
						</div> : 
                  <Cards.ClickHereContainer style={{ background: '#FFFFFF', color: "#F37021", fontSize:'14px' }}>
                      <p className="click_text">
                        <FaRegImages
                          style={{ height: "24px", width: "24px" }}
                        />
                        View Images
                      </p>
                    </Cards.ClickHereContainer>            
            }
    </a>
  );
};

export const NoImageAvailable = ({...props}) => {

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection:'column',
        alignItems: "center",
        justifyContent:'center',
        borderRadius:'8px',
        margin:`${props.margin ? props.margin : '0px 8px 0px 0px'}`,
        background:'#F1E5F1',
        minHeight:`${props?.minHeight}`,
        minWidth:`${props?.minWidth}`,
        maxWidth:`${props?.maxWidth}`,
        maxHeight:`${props?.maxHeight}`,
        padding:'8px'
      }}
    >
      <img style={{width:`${props.imgWidth}`, height:`${props.imgHeight}`}} src="../assets/icons/tractor_icon.svg" alt="" />
    </div>
  );
};


export const MobileNoImageAvailable = () => {
  return (
    <div style={{ position: "relative" }}>
      <span
        style={{
          position: "absolute",
          color: "#FFFFFF",
          top: "35%",
          left: "25%",
          fontWeight: "800",
          fontSize: "14px",
        }}
      >
        NO IMAGE AVAILABLE
      </span>
      <Cards.Image src="../assets/tractor_image1.png" alt="" />
    </div>
  );
};
